/* build:2026-06-03-nav */
/**
 * wudy-perf.js
 * Wudy Kitchen — UX friction fixes (dead clicks, hash scroll, touch CTAs)
 */
(function () {
  'use strict';

  function prefersSmoothScroll() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function scrollToHash(hash, behavior) {
    if (!hash || hash.length < 2) return;
    var target = document.querySelector(hash);
    if (!target) return;
    target.scrollIntoView({ behavior: behavior || 'instant', block: 'start' });
  }

  function samePageUrl(url) {
    return url.pathname === window.location.pathname && url.search === window.location.search;
  }

  function bindHashScroll() {
    window.addEventListener('popstate', function (event) {
      var hash = window.location.hash;
      if (!hash) {
        if (event.state && typeof event.state.wudyScrollY === 'number') {
          window.scrollTo({ top: event.state.wudyScrollY, behavior: 'auto' });
        }
        return;
      }
      scrollToHash(hash, 'instant');
    });

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var anchor = e.target.closest('a[href*="#"]');
      if (!anchor) return;
      var raw = anchor.getAttribute('href');
      if (!raw || raw === '#') return;

      var linkUrl;
      try {
        linkUrl = new URL(raw, window.location.origin);
      } catch (err) {
        return;
      }
      if (!samePageUrl(linkUrl)) return;

      var hash = linkUrl.hash;
      if (!hash || hash.length < 2) return;
      var target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();
      var smooth = prefersSmoothScroll();
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var nextUrl = window.location.pathname + window.location.search + hash;

      if (window.location.hash !== hash && history.pushState) {
        history.pushState({ wudyHash: true, wudyScrollY: scrollY }, '', nextUrl);
      } else if (history.replaceState) {
        history.replaceState({ wudyHash: true, wudyScrollY: scrollY }, '', nextUrl);
      }

      scrollToHash(hash, smooth ? 'smooth' : 'instant');
    });
  }

  function bindMaterialCardImages() {
    document.querySelectorAll('.wudy-material-card').forEach(function (card) {
      var link = card.querySelector('.wudy-material-card__link');
      var wrap = card.querySelector('.wudy-material-card__image-wrap');
      if (!link || !wrap || wrap.querySelector('a')) return;
      wrap.setAttribute('role', 'link');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('aria-label', link.getAttribute('aria-label') || link.textContent.trim());
      function go() {
        window.location.href = link.href;
      }
      wrap.addEventListener('click', go);
      wrap.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          go();
        }
      });
    });
  }

  function neutralizeEmptyHashLinks() {
    document.querySelectorAll('a[href="#"]').forEach(function (anchor) {
      anchor.setAttribute('aria-disabled', 'true');
      anchor.style.cursor = 'default';
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
      });
    });
  }

  function exposeTouchProductCtas() {
    if (!window.matchMedia('(hover: none)').matches) return;
    document.documentElement.classList.add('wudy-touch');
  }

  function healSummer26StaleCache() {
    if (!/\/collections\/summer-26\/?$/.test(window.location.pathname)) return;

    var grid = document.getElementById('s26-collection-grid');
    var list = grid ? grid.querySelector('.s26-grid__list') : null;
    var cols = list && list.getAttribute('style') ? list.getAttribute('style') : '';
    var productCount = grid ? grid.querySelectorAll('.s26-card__title').length : 0;
    var prefixNode = document.querySelector('[id^="shopify-section-template--"]');
    if (!prefixNode) return;
    var prefixMatch = prefixNode.id.match(/^shopify-section-(template--\d+__)/);
    if (!prefixMatch) return;
    var prefix = prefixMatch[1];
    var missingSubcat = !document.getElementById('shopify-section-' + prefix + 's26v2_subcat');
    var needsHeal =
      cols.indexOf('--s26-cols:4') === -1 ||
      productCount < 8 ||
      document.documentElement.innerHTML.indexOf('repeat(auto-fill, minmax(230px, 1fr))') !== -1 ||
      missingSubcat;

    if (!needsHeal) return;

    var keys = [prefix + 's26v2_dynamic', prefix + 's26v2_limited'];
    if (missingSubcat) {
      keys.unshift(prefix + 's26v2_subcat');
    }

    keys.forEach(function (key) {
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(key), {
        credentials: 'same-origin',
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (payload) {
          var html = payload[key];
          if (!html) return;
          var wrap = document.createElement('div');
          wrap.innerHTML = html.trim();
          var fresh = wrap.firstElementChild;
          if (!fresh) return;
          var current = document.getElementById('shopify-section-' + key);
          if (current) {
            current.replaceWith(fresh);
            return;
          }
          if (key.indexOf('s26v2_subcat') !== -1) {
            var anchor = document.getElementById('shopify-section-' + prefix + 's26v2_ritual');
            if (anchor) anchor.insertAdjacentElement('afterend', fresh);
          }
        })
        .catch(function () {});
    });
  }

  function init() {
    bindHashScroll();
    bindMaterialCardImages();
    neutralizeEmptyHashLinks();
    exposeTouchProductCtas();
    healSummer26StaleCache();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
